import React, { useState } from "react";
import { InputLabel, Stack, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styleInputDefault } from "../../../../theme";
import ButtonWithAnalytics from "../ButtonWithAnalytics";

interface Props {
  type: string;
  onChange?: (data: any) => void;
  hideInput?: (value: boolean) => void;
}

export default function MedicalConditionInput({
  onChange,
  type,
  hideInput,
}: Props) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  function onAdd() {
    if (onChange) {
      onChange(inputValue);
    }
    if (hideInput) {
      hideInput(false);
    }
    setInputValue("");
  }

  function onClear() {
    if (hideInput) {
      hideInput(false);
    }
    setInputValue("");
  }

  return (
    <Stack
      role="form"
      aria-label={t(`${type}.addNewFormLabel` as any)}
      flexGrow={2}
      spacing={1}
    >
      <InputLabel>{t(`${type}.inputLabel` as any)}</InputLabel>
      <TextField
        onChange={(
          event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => setInputValue(event.target.value)}
        value={inputValue}
        slotProps={{
          htmlInput: {
            autoComplete: "off",
            inputMode: "text",
            "aria-label": t(`${type}.inputLabel` as any),
          },
        }}
        size="small"
        placeholder={t(`MedicalConditionList.placeholder`)}
        sx={{
          input: {
            ...styleInputDefault,
          },
        }}
      />
      <Stack flexDirection="row" gap={1}>
        <ButtonWithAnalytics
          page="MedicalConditionInput"
          text={t(`common.cancelButton`)}
          intent="confirmational"
          variant="outlined"
          fullWidth
          size="small"
          color="neutral"
          onClick={onClear}
        >
          {t(`common.cancelButton`)}
        </ButtonWithAnalytics>
        <ButtonWithAnalytics
          page="MedicalConditionInput"
          text={t(`MedicalConditionList.addLabel`)}
          intent="confirmational"
          variant="contained"
          disabled={!inputValue}
          fullWidth
          size="small"
          color="neutral"
          onClick={onAdd}
        >
          {t(`MedicalConditionList.addLabel`)}
        </ButtonWithAnalytics>
      </Stack>
    </Stack>
  );
}
